<style>
.negrilla {
  color: #363636 !important;
}
</style>
<template>
  <card class="custom-container">
    <div class="row p-4">
      <div class="col-12 col-lg-6 mx-auto">
        <span class="h2">Cargar Archivos</span>
        <div
          class="d-flex flex-column align-items-center mt-3"
          style="gap: 1rem"
        >
          <!-- drop file -->
          <DropFileBasic
            @handleFileData="handleFileData"
            :loader="loader"
            :fileTypes="[
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ]"
          />

          <div class="w-100">
            <label for="tipoFile" class="form-label">Tipo archivo</label>
            <b-form-select
              id="tipoFile"
              required
              v-model="tableName"
              value-field="valorExactoTabla"
              text-field="nombreTabla"
              :options="tablaSel"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  -- Selecciona una opcion --
                </b-form-select-option>
              </template>
            </b-form-select>
          </div>

          <vs-button @click="uploadFile" :disabled="!file || !tableName">
            Cargar Archivo
          </vs-button>
        </div>

        <div class="d-flex row align-items-start mt-4" style="gap: 1rem">
          <h2 class="col-10">
            <i class="fas fa-file-lines"></i>
            Plantillas Base
          </h2>
          <div
            class="col-12 d-flex row justify-content-center"
            v-for="(item, subIndex) in tablaSel"
            :key="subIndex"
          >
            <vs-button
              class="col-6"
              success
              flat
              :active="active == subIndex"
              @click="(active = subIndex), getPlantilla(item.nombreTabla)"
            >
              {{ item.nombreTabla }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Swal from "sweetalert2";
import DropFileBasic from "@/components/helexium/DropFileBasic.vue";
export default {
  components: {
    DropFileBasic,
  },
  data() {
    return {
      tablaSel: [
        {
          id: 1,
          nombreTabla: "Devoluciones",
          valorExactoTabla: "Devoluciones",
        },
        {
          id: 2,
          nombreTabla: "Implantes montados",
          valorExactoTabla: "ImplantesMontados",
        },
        {
          id: 3,
          nombreTabla: "Subvención y costos asociados",
          valorExactoTabla: "SubvencionCostosAsociados",
        },
        {
          id: 4,
          nombreTabla: "Liquidación PACK de fase higienica (Incentivos)",
          valorExactoTabla: "LiquidacionPacksFaseHigienicaIncentivos",
        },
      ],
      tableName: null,
      file: null,
      loader: false,
      error: null,
      activeModal: false,
      active: false,
    };
  },
  methods: {
    async getPlantilla(name) {
      try {
        // Hacemos la solicitud para obtener el archivo
        const response = await this.$store.dispatch("hl_get_file", {
          path: "UploadHonorarios/plantillasHonorariosExito/" + name,
          responseType: "blob", // Indicamos que la respuesta será un archivo
        });

        // Si la respuesta es correcta
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }); // Tipo de archivo Excel
        const link = document.createElement("a");

        // Creamos una URL para el archivo y la asignamos al enlace
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", name); // Nombre del archivo que se descargará
        document.body.appendChild(link);

        // Simulamos el click para forzar la descarga
        link.click();

        // Limpieza de URL y enlace
        link.remove();
        window.URL.revokeObjectURL(url);

        return response;
      } catch (error) {
        console.error("Error al descargar la plantilla:", error);
      }
    },

    handleFileData(event) {
      this.file = event;
      this.error = null;
    },

    async uploadFile() {
      if (!this.file || !this.tableName) return;

      this.error = null;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("tableName", this.tableName);

      try {
        Swal.fire({
          title: "Procesando archivo",
          html:
            "Por favor espere mientras se procesa el archivo...<br/>" +
            '<small class="text-muted">Este proceso puede tomar varios minutos dependiendo del tamaño del archivo.</small>',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        const response = await this.$store.dispatch("hl_post_file", {
          path: "UploadHonorarios/?tableName=" + this.tableName,
          data: formData,
        });
        await Swal.close();

        // Mostrar alerta de éxito
        if (response.status === 200) {
          await Swal.fire({
            icon: "success",
            title: "¡Éxito!",
            text: "El archivo se ha procesado correctamente.",
            confirmButtonText: "Aceptar",
          });
        } else {
          await Swal.close();
          // Acá obtenemos el BadRequest Generado desde el Backend
          const errorMessage = await response.text();
          console.log("Respuesta del servidor:", errorMessage);

          // Mostrar la alerta de error
          await Swal.fire({
            icon: "error",
            title: "¡Error al subir el archivo!",
            text:
              "Mensaje de error: " +
                errorMessage +
                "\nPor favor revisa el contenido del archivo o contacta con soporte" ||
              "\nError al procesar el archivo, Por favor revisa el contenido del archivo o contacta con soporte",
            confirmButtonText: "Aceptar",
          });
        }

        //console.log("Respuesta del servidor:", response);

        this.$emit("upload-success");
        this.file = null;
        this.tableName = null;
      } catch (error) {
        await Swal.close();
      }
      //window.location.reload();
    },
  },
};
</script>
